// Module
var code = `{{#}}
<a
  data-channel="ROUTE"
  data-page-id="{{pageId}}"
  data-topic-id="{{topicId}}"
  data-option-id="{{optionId}}"
  data-event-type="menuDrawer"
  data-event-prevent-default="true"
  data-nav-href="{{href}}"
  class="flex h-[48px] grow items-center justify-center gap-2 rounded-md bg-gray-50 p-3 text-sm font-medium hover:bg-sky-100 hover:text-blue-600 md:flex-none md:justify-start md:p-2 md:px-3"
  href="{{href}}"
  >{{svgIcon}}
  <p class="hidden md:block">{{navTitle}}</p></a
>
{{/}}
`;
// Exports
module.exports = code;